export default "/images/map2.svg";